import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { Button, Dialog, DialogActions, DialogContent, Grid, Tooltip } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import { NewTable } from '../../components/datatable/NewTable'
import SimpleDatePicker from '../../components/forms/SimpleDatePicker'
import EventsAction from '../../events/actions/EventsAction'
import CityAction from '../../referencial/components/city/actions/CityAction'
import { getLabel } from '../../utils/StoreUtils'
import MonitoredStationEventDto from '../dto/MonitoredStationEventDto'
import NotificationsIcon from '@mui/icons-material/Notifications'

const HEADERS = ['nullValue', 'code', 'city', 'name', 'event']

const MonitoredStationCard = ({ stations = [], onClickEnable = true }) => {
    const dispatch = useDispatch()
    const cities = useSelector(state => state.CityReducer.cities)

    const [selectedStation, setSelectedStation] = useState(null)
    const [closeDate, setCloseDate] = useState(Date.now())

    useEffect(() => {
        dispatch(CityAction.fetchCities())
    }, [dispatch])

    const refreshStationList = () => dispatch(EventsAction.fetchMonitoredStations())

    const updateEvent = () => {
        dispatch(EventsAction.updateEvent(selectedStation.type, selectedStation.id, selectedStation.eventId, { closeDate }, refreshStationList))
        setSelectedStation(null)
    }

    const openPopup = (station) => {
        setCloseDate(Date.now())
        setSelectedStation(station)
    }

    const rows = stations.map(station => ({
        station,
        code: `${station.code}${station.designation ? ` /${station.designation}` : ''}`,
        city: getLabel(cities, station.townCode, undefined, undefined, station.townCode),
        name: station.name,
        event: station.eventProblem || station.eventSolution || station.eventComment,
        nullValue: {
            value: (
                <Tooltip title={i18n.oversight}>
                    <NotificationsIcon color='error'/>
                </Tooltip>
            ),
        },
    }))

    return (
        <>
            <NewTable
                rows={rows}
                headers={HEADERS}
                onClickRow={onClickEnable ? row => openPopup(row.station) : undefined}
            />
            <Dialog open={!!selectedStation} onClose={() => setSelectedStation(null)} maxWidth='sm' fullWidth>
                <DefaultDialogTitle title={i18n.eventMonitored} onClose={() => setSelectedStation(null)} />
                <DialogContent>
                    {selectedStation && (
                        <>
                            {selectedStation.eventProblem && (<h6><b>{i18n.problem} :</b> {selectedStation.eventProblem}</h6>)}
                            {selectedStation.eventSolution && (<h6><b>{i18n.solution} :</b> {selectedStation.eventSolution}</h6>)}
                            {selectedStation.eventComment && (<h6><b>{i18n.comment} :</b> {selectedStation.eventComment}</h6>)}
                            <StyledFieldSet>
                                <StyledLegend>{i18n.closeTheEvent}</StyledLegend>
                                <Grid container justifyContent='center'>
                                    <Grid size={6}>
                                        <SimpleDatePicker
                                            id='end-date'
                                            label={i18n.endDate}
                                            value={closeDate}
                                            min={selectedStation.eventDate}
                                            onChange={setCloseDate}
                                        />
                                    </Grid>
                                </Grid>
                            </StyledFieldSet>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={updateEvent}>
                        {i18n.validate}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

MonitoredStationCard.propTypes = {
    stations: PropTypes.arrayOf(PropTypes.instanceOf(MonitoredStationEventDto)),
    onClickEnable: PropTypes.bool,
}

export default MonitoredStationCard
